import { inject, PLATFORM_ID } from '@angular/core';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BrowserIdService } from '../services/browser-id.service';
import { LoggedInUser } from '../models/logged-in-user.model';
import { decryptData } from '../constants/enc-dec.helper';
import { isPlatformServer } from '@angular/common';
import { AdditionalInfoService } from '../services/additional-info.service';

interface requestUrlObj {
  user_id: string;
  device_id: string;
  platform: string;
  session_id: string;
  additional_data?: any;
}

export const attachEncodedDataKeyInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
    next: HttpHandlerFn
) => {
  
 
  const platformId = inject(PLATFORM_ID);
  if (isPlatformServer(platformId)) {
    return next(req);
  }
  const browserIdService = inject(BrowserIdService);
  const additionalInfoService = inject(AdditionalInfoService);

  function base64Encode(obj: requestUrlObj): string {
    const json = JSON.stringify(obj);
    const bytes = new TextEncoder().encode(json);
    const base64 = btoa(String.fromCharCode(...bytes));
    return base64;
  }

  return from(browserIdService.getBrowserId()).pipe(
    switchMap((deviceId) => {
      let userDetails: LoggedInUser = null;

      if (isPlatformServer(platformId)) {
        const loggedInUserKey = 'idp-user-profile';
        const encryptedProfile = localStorage.getItem(loggedInUserKey);
        userDetails = decryptData(encryptedProfile);
      }

      const requestData: requestUrlObj = {
        user_id: userDetails?.user?.id || '',
        device_id: deviceId,
        platform: 'web',
        session_id: userDetails?.token || '',
      };

      const additionalInfo = additionalInfoService.getAdditionalInfo(req.url);
      if (additionalInfo) {
        requestData['additional_data'] = additionalInfo;
        additionalInfoService.clearAdditionalInfo(req.url);
      }
      const encodedData = base64Encode(requestData);

      const modifiedReq = req.clone({
        setHeaders: {
          data: encodedData,
        },
      });

      return next(modifiedReq);
    })
  );
};
